export enum GenderType{
    FEMENINO = "F",
    MASCULINO = 'M',
    NO_BINARIO = 'NB'
}